import { Dialog, DialogContent } from "@/components/ui/dialog";
import { NotificationsContent } from "./notifications/NotificationsContent";

interface NotificationsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function NotificationsModal({ open, onOpenChange }: NotificationsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-card">
        <NotificationsContent title="Notifications" />
      </DialogContent>
    </Dialog>
  );
}
